import { Accordion, AccordionDetails, AccordionSummary, Box, CircularProgress, Container, Divider, Grid, TextField, Typography } from '@mui/material';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import { StyledEngineProvider } from '@mui/material/styles';
import { TrazabilidadBackground } from '../../../assets/vectors/TrazabilidadBackground';
import { Checkbox, Button } from '@mui/material';
import {  StylesProvider, createGenerateClassName } from '@material-ui/core';
import {
  AttributeMultipleCheckbox,
  AttributeImages,
  AttributeTokens,
  AttributeTable,
  AttributePlain,
  AttributeDate,
  AttributeLink,
  AttributeText,
  AttributeFile,
  MapJourney,
  TimeLine,
  Footer,
  PhotoCarrousel,
} from '../components';
import { Spinner } from "reactstrap"
import { ASSET_STATES, DEFAULT_LANGUAGES } from '../../../constants';
import { Trans, useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { IMAGES_PATH } from '../../../constants/paths';
import {
  AttributeMadurationChart,
} from './AttributeMadurationChart';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { AttributeSelectImages } from './AttributeSelectImages';
import QrAccordion from './QrAccordion';
import LanguageSelect from '../../../Components/LanguageSelect';
import { getInitialLanguage } from '../../../Helpers/translation';
import { getAttributeValue, stateRules } from '../../../Helpers/assetHelper';
import CustomThemeProvider from './CustomThemeProvide';
import { translateFunc } from '../../../Helpers/translateFunc';
import MapAssets from '../../../Components/Generic/MapAssets';

export const QrTemplate = ({
  customData,
  sections = [],
  attributes,
  qrModelTheme,
  qrModelLogo,
  qrModelLogoWoText,
  onSubmit,
  errorMessage,
  flagApology,
  qrErrorImg,
  editMode,
  setFieldsStates,
  isLoading,
}) => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const getLanguagesFromStorage = () => {
    try {
      const storedLanguages = localStorage.getItem('languagesAvailables');
      return storedLanguages ? JSON.parse(storedLanguages) : DEFAULT_LANGUAGES;
    } catch (error) {
      console.error("Error al parsear JSON desde localStorage:", error);
      return DEFAULT_LANGUAGES;
    }
  };  
  const [openAccordions, setOpenAccordions] = useState([]);
  const [selectedLang, setSelectedLang] = useState(getInitialLanguage());
  const [languages] = useState(getLanguagesFromStorage());
  const { handleSubmit, control } = useForm()
  const myForm = useRef(null);
  const generateClassName = createGenerateClassName({
    seed: 'qr-theme',
  });
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  useEffect(() => {
    const initialLang = getInitialLanguage();
    if (i18n.language !== initialLang) {
      i18n.changeLanguage(initialLang).then(() => {
        setSelectedLang(initialLang);
      });
    } else {
      setSelectedLang(initialLang);
    }
  }, []);
  
  const isMobile = width <= 768;

  const isValidData = (value) => {
    let outcome = false
    if (Array.isArray(value)) {
      outcome = (value.length > 0)
    } else {
      outcome = (value !== undefined && value !== null && value !== '')
    }
    return outcome
  }

  const doesTimeLineHaveAnyGoodValues = (values) => {
    for (let value of values) {
      if (value.lat !== null && value.lon !== null) {
        return true
      }
    }
    return false
  }

  const handleChangeLanguage = (event) => {
    const newLang = event.target.value;
    setSelectedLang(newLang);
    i18n.changeLanguage(newLang);
    localStorage.setItem('selectedLanguage', newLang);
  };

  const onChangeFields = (name, isEnable, value) => {
    setFieldsStates((prevFields) => {
      const existingFieldIndex = prevFields.findIndex(field => field.name === name);
      
      if (existingFieldIndex !== -1) {
        const updatedFields = [...prevFields];
        updatedFields[existingFieldIndex] = { name, isEnable, value };
        return updatedFields;
      } else {
        return [...prevFields, { name, isEnable, value }];
      }
    });
  }
  
  const determineObjectState = (attributes) => {
    const idAssetType = getAttributeValue(attributes, "id_asset_type");
    
    if (!idAssetType || !stateRules[idAssetType]) {
      return null;
    }
  
    const rule = stateRules[idAssetType];
    return rule ? rule(t, attributes)?.[0] : t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.${ASSET_STATES.PRODUCTIVO}`);
  };
    
  const createStateAttribute = (attributes) => {
    const stateValue = determineObjectState(attributes);
    if (!stateValue) return null;
    return {
        name: "state",
        type: "text",
        isEnabled: true,
        data: {
          label: "Estado del Activo",
          value: stateValue
        },
        visible: true,
        isUserConfigurable: false
    };
  };
  
  const enhancedAttributes = useMemo(() => {
    if (!attributes || attributes.length === 0) return attributes;
    const stateAttribute = createStateAttribute(attributes);

    return stateAttribute ? attributes.map(att => att.name === 'paused' ? stateAttribute : att) 
    : attributes;
  }, [attributes]);

  const orderAttributesWithSections = (attributes, sections) => {
    if (!sections || sections.length === 0) {
      return [{ title: null, attributes }];
    }
  
    const ungruppedAtt = [];
    const journeyAtt = [];
    
    attributes.forEach(att => {
      if (['timeLine', 'productJourney'].includes(att.name)) {
        journeyAtt.push(att);
      } else if (!sections.some(section => section.fields.includes(att.name))) {
        ungruppedAtt.push(att);
      }
    });
  
    const sectionsWithAtt = [];
  
    sections.forEach(section => {
      const sectionAtt = [];
      section.fields.forEach(field => {
        const fieldSect = attributes.find(att => att.name === field && att.data?.value);

        fieldSect && sectionAtt.push(fieldSect);
      });

      const objNewSection = { title: section.title, attributes: sectionAtt }

      if (section.boxName)
        objNewSection.boxName = section.boxName
  
      sectionsWithAtt.push(objNewSection);
    });
  
    return [
      { title: null, attributes: ungruppedAtt }, 
      ...sectionsWithAtt,
      { title: null, attributes: journeyAtt }, 
    ];
  }
  
  const renderAttributeBlock = (att, index) => {
    if (att.hide) return (null);
    
    return (
      <div 
        style={
          editMode && 
          (Array.isArray(att.data.value) 
            ? att.data.value.length > 0 
            : att.data.value
          ) 
          ? { border: '1px dashed #aaa', padding: '2rem 1rem', display: 'flex', flexDirection: 'row', alignItems:'center' } 
          : {}
        } 
        key={index}
      >
        {(
          editMode
          && att.type !== "selectimages"
          && (att.isEnabled || att.isUserConfigurable)
        ) &&
          <div style={{ display: 'flex' }}>
            <Controller
              render={({ field: { name, value, onChange } }) => (
                <Checkbox
                  name={name}
                  checked={value}
                  disabled={!att.isUserConfigurable}
                  onChange={onChange} 
                />
              )}
              control={control}
              name={att.name}
              key={att.name}
              defaultValue={att.isEnabled}
            />
          </div>
        }
        {renderField(att, index)}
      </div>
    )
  }

  const renderField = (att, index) => {
    switch (att.type) {
      case 'text':
      case 'extraTimeline':
        return (
          <div>
            {att.data.value && (editMode || att.isEnabled) &&
              <>
                <AttributeText tt={t} data={att.data} subType={'text'} type={att.type}/>
                {!editMode && <Divider/>}
              </>
            }
          </div>
        );
      case 'checkbox':
        return (
          <div>
            {att.data.value && (editMode || att.isEnabled) &&
              <>
                <AttributeText tt={t} data={att.data} subType={'checkbox'}/>
                {!editMode && <Divider/>}
              </>
            }
          </div>
        );
      case 'location':
        return (att.values &&
          <>
            <Typography color='primary.main' variant='h3' marginBottom={1}>
              {t(`basicFormStepByStep.placeholdersTranslate.${att.name}`)}
            </Typography>
            <MapAssets
              assetList={att.values}
            />
            <Divider/>
          </>
        );
      case 'boxTarget':
        return (
          <div>
            {att.data.value && (editMode || att.isEnabled) &&
              <>
                <AttributeText tt={t} data={att.data} subType={'boxTarget'}/>
                {!editMode && <Divider/>}
              </>
            }
          </div>
        );
      case 'url':
        return (
          <div>
            {isValidData(att.data.value) && (editMode || att.isEnabled) &&
              <>
                <AttributeLink tt={t} data={att.data} />
                {!editMode && <Divider/>}
              </>
            }
          </div>
        )
      case 'video':
        return (
          <div >
            {att.videoUrl && att.isEnabled && att.videoOrigin &&
              <>
                <iframe
                  title={`iframe-${att.videoOrigin}`}
                  src={
                    (att.videoOrigin === 'shortYT' || att.videoOrigin === 'videoYT') ? `https://www.youtube.com/embed/${att.videoUrl}`
                    : att.videoOrigin === 'googleDrive' && `https://drive.google.com/file/d/${att.videoUrl}/preview`
                  }
                  style={{
                    width: isMobile ? '350px' : '700px',
                    height: isMobile ? '150px' : '400px',
                    border: 'none' 
                  }}
                  allow="autoplay"
                  allowFullScreen
                />
                {!editMode && <Divider/>}
              </>
            }
          </div>
        )
      case 'plain':
        return (
          <div>
            {isValidData(att.data.value) && (editMode || att.isEnabled) &&
              <>
                <AttributePlain tt={t} data={att.data} />
                {!editMode && <Divider/>}
              </>
            }
          </div>
        )
      case 'date':
        return (
          <div>
            {isValidData(att.data.value) && (editMode || att.isEnabled) &&
              <>
                <AttributeDate tt={t} data={att.data} />
                {!editMode && <Divider/>}
              </>
            }
          </div>
        );
      case 'chart':
        const slaughterDate = attributes.find(
          (a) => a.name === 'slaughterDate'
        );
        const hasValidSlaughterDate =
          slaughterDate &&
          slaughterDate.data &&
          new Date(slaughterDate.data.value).toString() !== 'Invalid Date';

        return (
          <div>
            {isValidData(att.data.value) && (editMode || att.isEnabled) && (
              <>
                {hasValidSlaughterDate && (
                  <AttributeMadurationChart
                    value={att.data}
                    data={att}
                    tt={t}
                  />
                )}
                {!editMode && <Divider/>}
              </>
            )}
          </div>
        );
      case 'images':
        const validImages = isValidData(att.data.value) &&
          (!Array.isArray(att.data.value) || att.data.value.filter(img => img !== null).length > 0);
        
        return (
          <div style={{ width: '100%' }}>
            {validImages && (editMode || att.isEnabled) && (
              <>
                <AttributeImages tt={t} data={att.data} />
                {!editMode && <Divider/>}
              </>
            )}
          </div>
        )
      case 'selectimages':
      case 'imagesDetail':
        return (
          <div style={{ width: '100%' }}>
            {(isValidData(att.data.value)) && (editMode || att.isEnabled) &&
              <>
                <AttributeSelectImages tt={t} data={att.data} editMode={editMode} isEnable={att.isEnabled} enableValues={att.enableValues} onChangeFields={onChangeFields} />
                {!editMode && <Divider/>}
              </>
            }
          </div>
        )
      case 'tokens':
        const tokenCount = Array.isArray(att.data.value) ? att.data.value.length : 1;
        const shouldUseAccordion = tokenCount > 44;

        return (
          <div style={{ width: '100%', marginTop: 2 }}>
            {shouldUseAccordion ? (
              <QrAccordion
                title={`${translateFunc(t,`basicFormStepByStep.placeholdersTranslate.${att.data.label}`, att.data.label)} (${tokenCount})`}
                data={att.data}
                t={t}
              />
            ) : (
              <Box sx={{ width: '100%', marginTop: 2}}>
                <AttributeTokens tt={t} data={att.data} />
              </Box>
            )}
            {!editMode && <Divider/>}
          </div>
      );
      case 'multipleCheckbox':
        return (
          <div style={{ width: '100%' }}>
            {isValidData(att.data.value) && (editMode || att.isEnabled) &&
              <>
                <AttributeMultipleCheckbox tt={t} data={att.data} />
                {!editMode && <Divider/>}
              </>
            }
          </div>
        )
      case 'table':
        return (
          <div style={{ width: '100%' }}>
            {isValidData(att.data.value.values) && (editMode || att.isEnabled) &&
              <AttributeTable tt={t} data={att.data} theme={qrModelTheme}/>
            }
          </div>
        )
      case 'productJourney':
        return (
          att.values !== undefined && doesTimeLineHaveAnyGoodValues(att.values) && (editMode || att.isEnabled) &&
          <div style={{ width: '100%' }}>
            <Typography color='primary.main' variant='h3' className='pt-2'>
              {t('qrTemplate.productJourney')}
            </Typography>
            <Box
              sx={{
                width: '100%',
                height: '393.01px',
                borderRadius: '17px',
              }}
              className='mt-2 mb-1'
            >
              <MapJourney information={att.values.slice().reverse()} logoWoText={qrModelLogoWoText}/>
            </Box>
          </div>
        )
      case 'timeLine':
          return (
            att.values !== undefined && att.values.length > 0 && (att.isEnabled) &&
            <div style={{ width: '100%'}}>
              <Typography color='primary.main' variant='h4' className='pt-2 mb-2'>
                {t(`qrTemplate.${att.label ? att.label : 'Recorrido'}`)}
              </Typography>
              <TimeLine tt={t} information={att.values.slice().reverse()} enableExtraParams={att.enableValues} logoWoText={qrModelLogoWoText}/>
            </div>
          )
      case 'customDescription':
        return (
          att.values && (att.isEnabled) &&
          <div style={{ width: '100%', marginTop: "2rem" }}>
            {att.values?.map(section => 
              renderCustomDescription(section)
            )}
          </div>
        )
      case 'description':
        const language = selectedLang.split('_')
        return (
          att.values && (att.isEnabled) &&
          <div style={{ width: '100%', paddingBottom: "2rem" }}>
            <Typography color='text.primary' variant='h2' className='pt-3 pb-3'>
              {t('qrTemplate.description')}
            </Typography>
            <Typography color='text.primary' variant='body1' className='pt-2'>
              {language.length > 1 ? att.values[language[1]] : att.values[selectedLang]}
            </Typography>
          </div>
        )
      case 'file':
        return ( 
          att.data.value && (att.isEnabled) &&
          <div style={{ width: '100%' }}>
            <AttributeFile  tt={t} data={att.data}/>
          </div>
        )
      default:
        return (
          <>
          </>
        )
    }
  }
  
  useEffect(() => {
    if (editMode) return;

    const titles = attributes
      ?.flatMap(attr =>
        attr.type === "customDescription"
          ? attr.values
              ?.filter(v => v.type === "accordion" && v.expandedDefault)
              .map(v => v.title)
          : []
      )
      .filter(Boolean) ?? [];

    if (!titles.length) return;

    setOpenAccordions(prev => {
      const toAdd = titles.filter(t => !prev.includes(t));
      return toAdd.length ? [...prev, ...toAdd] : prev;
    });
  }, [attributes, editMode]);

  const renderCustomDescription = (field, insideAccordion = false) => {
    switch (field.type) {
      case 'accordion':
        return (
          <Accordion 
            expanded={openAccordions?.includes(field.title)}
            onChange={() => {
              setOpenAccordions(prev =>
                prev.includes(field.title)
                  ? prev.filter(title => title !== field.title)
                  : [...prev, field.title]
              );
            }}
            sx={{ 
              marginY: 2,
              backgroundColor: 'background.default',
              boxShadow: theme => `0 0 10px ${theme.palette.primary.dark}99`,
              borderRadius: 2.5,
              '&:first-of-type': {
                borderRadius: 2.5,
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main' }}/>}
              aria-controls="panel1-content"
              id={`${field.title}-header`}
            >
              <Typography variant="h3" sx={{ color: 'primary.main' }}>
                {t(`qrTemplate.customDescription.${field.title}`)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {field.value?.map(f => renderCustomDescription(f, true))}
            </AccordionDetails>
          </Accordion>
        );
      case 'textTranslate':
      case 'titleTranslate':
        const isTitle = field.type === 'titleTranslate'

        return (
          <Typography 
            color={isTitle ? 'primary.main' : 'secondary.main'}
            variant={isTitle ? 'h4' : 'subtitle1'}
            sx={{
              marginBottom: isTitle ? 2 : 0
            }}
          >
            <Trans
              i18nKey={`qrTemplate.customDescription.${isTitle ? field.title : field.value}`}
              components={[
                // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                />,
                // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
                <a 
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                     setOpenAccordions(prev =>
                      prev.includes('whatIsRegenerativeFarming') ? prev : [...prev, 'whatIsRegenerativeFarming']
                    );
                    const el = document.getElementById(t(`qrTemplate.customDescription.${field.value}ReferenceId`));
                    if (el) {
                      const offset = el.getBoundingClientRect().top + window.scrollY;const height = window.innerHeight;
                      const target = offset - (height / 2) + (el.offsetHeight / 2);
                      window.scrollTo({ top: target, behavior: 'smooth' });
                    }}
                  }
                />
              ]}
            />
          </Typography>
        );
      case 'image':
        return (
          field.srcs && 
            <Box
              sx={{
                marginBottom: 2
              }}
            >
              <PhotoCarrousel 
                photos={field.srcs}
                sx={{ 
                  width: '100%',
                }}
              />
            </Box>
        )
      case 'video': 
        return (
          <Box
            sx={{
              width: '100%',
              maxWidth: '100%',
              position: 'relative',
              pt: '56.25%', 
              marginTop: 1
            }}
          >
            <Box
              component="iframe"
              title={field.title}
              src={field.src}
              allowFullScreen
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: 3
              }}
            />
          </Box>
        )
      case 'divider':
        return (
          <Divider/>
        )
      default:
        break;
    }
  }

  const renderDescriptionEdit = (descripcion) => {
    return (
      <div style={editMode ? { border: '1px dashed #aaa', padding: '1rem', display: 'flex', flexDirection: 'row' } : {}} className='mt-3'>
        <div style={{ paddingTop: '30px', display: 'flex', alignItems: 'center' }}>
          <Controller
            render={({ field: { name, value, onChange } }) => (
              <Checkbox
                name={name}
                checked={value}
                disabled={!descripcion.isUserConfigurable}
                onChange={onChange}
              />
            )}
            control={control}
            defaultValue={descripcion?.isEnabled}
            name={'description'}
          />
        </div>

        <div style={{ width: '100%' }}>
          <Typography color='text.primary' variant='h2' className='pt-3 pb-3'>
            {t('qrTemplate.description')}
          </Typography>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', marginTop: '1rem'  }}>
            <div style={{ width: '50%' }}>
              <Typography color='text.primary' variant='body2' className='mb-3'>
                {t('qrTemplate.version.spanish')}
              </Typography>
              <Controller
                render={({ field: { name, value, onChange } }) => (
                  <TextField
                    sx={{ 
                      '& .MuiInputBase-root': { height: '250px' } ,
                      '& legend': { display: 'none' },
                      '& fieldset': { top: 0 },
                    }}
                    multiline
                    fullWidth
                    label=''
                    name={name}
                    value={value}
                    onChange={onChange}
                  />
                )}
                control={control}
                name={'descriptionEsp'}
                defaultValue={descripcion?.values.es}
              />
            </div>
            <div style={{ width: '50%' }}>
              <Typography color='text.primary' variant='body2' className='mb-3'>
                {t('qrTemplate.version.english')}
              </Typography>
              <Controller
                render={({ field: { name, value, onChange } }) => (
                  <TextField
                    sx={{ 
                      '& .MuiInputBase-root': { height: '250px' } ,
                      '& legend': { display: 'none' },
                      '& fieldset': { top: 0 },
                    }}
                    multiline
                    fullWidth
                    label=''
                    name={name}
                    value={value}
                    onChange={onChange}
                  />
                )}
                control={control}
                name={'descriptionEng'}
                defaultValue={descripcion.values.en}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <StyledEngineProvider injectFirst>
      {!attributes &&
        <div style={{ width: "100%", textAlign: "center", marginTop: "50px", display: "flex", flexDirection: "column", alignItems: "center", gap: "2rem" }}>
          <img
            src={`${IMAGES_PATH}/origino_logo.png`}
            className='pt-4'
            style={{ width: '250px', height: 'auto' }}
            alt='logo origino'
          />

          {errorMessage ?
            <div class='text-center'>
              <Container className='container-trazabilidad'>
                {flagApology && <Typography variant="h6" color='text.primary' style={{ marginBottom: 5 }}>
                  {t('qrTemplate.weAreSorry')} &#128542;
                </Typography>}
                {qrErrorImg && 
                  <Box
                    component="img"
                    sx={{
                      height: 400,
                      width: 700,
                      objectFit: 'cover',
                      borderRadius: 3,
                      marginBottom: 1
                    }}
                    alt="QR Image Error"
                    src={qrErrorImg}
                  />
                }
                <Typography color='text.primary' >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: errorMessage,
                    }}
                  />
                </Typography>
              </Container>
              <Footer qrModelLogo={qrModelLogo}/>
            </div >
            : <Spinner size="sm" type="grow" />
          }
        </div>
      }
      <StylesProvider generateClassName={generateClassName}>
        <CustomThemeProvider modelStyle={qrModelTheme}>
          {!editMode && <TrazabilidadBackground/>}

          {attributes &&
            <>
              <Container className='container-trazabilidad' component={'form'} noValidate
                ref={myForm} onSubmit={handleSubmit(onSubmit)} sx={{minWidth:'min-content'}}>
                {!editMode
                  ?
                  <div style={{ paddingTop: '0rem', paddingBottom: '2rem', display: 'flex', justifyContent: 'flex-end' }} align="right">
                    <LanguageSelect 
                      value={selectedLang}
                      onChange={handleChangeLanguage}
                      languages={languages}
                      sx={{
                        color: 'primary.main',
                        '&.MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'primary.main',
                          },
                          '&:hover fieldset': {
                            borderColor: 'primary.dark',
                          },
                        },
                        '& .MuiSelect-icon': {
                          color: 'primary.main', 
                        },
                        '& .MuiPaper-root': {
                          backgroundColor: 'secondary.main',
                        },
                      }}
                      sxItem={{
                        color: 'background.default',
                        '&:hover': {
                          backgroundColor: 'secondary.dark',
                        },
                      }}    
                    />
                  </div>
                  :
                  <div style={{ paddingBottom: '0.5rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }} >
                    <Button variant='outlined' onClick={() => history.goBack()} disabled={isLoading}>{t('qrTemplate.buttons.cancel')}</Button>
                    <Button variant='outlined' sx={{display: 'inline-flex', justifyContent: 'center', alignItems: 'center', gap: 1 }} type='submit' disabled={isLoading}>
                      {isLoading && <CircularProgress size={14} style={{color: 'inherit'}}/>}
                      {t('qrTemplate.buttons.saveTemplate')}
                    </Button>
                  </div>
                }

                <Typography 
                  height={'100%'}
                  color='primary.main' 
                  variant='h2'
                  display="flex"
                  alignItems="end"
                >
                  {t('qrTemplate.welcome')} 👋
                </Typography>

                <Grid container spacing={2} alignItems={'center'}>
                  <Grid item xs={12} md={customData?.subtitle ? 10 : 12}>
                    <Typography color='primary.dark' variant='h1' className='pt-1'>
                      {t(`qrTemplate.${customData?.title ? customData.title : 'knowEverythingAboutThisProduct'}`)}
                    </Typography>
                  </Grid>
                  {customData?.subtitle &&
                    <Grid 
                      item xs={12} 
                      md={customData?.subtitle ? 2 : 12} 
                      justifyItems="center"
                    >
                      <Box
                        sx={{
                          width: 160,
                          height: 160,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                          bgcolor: 'background.default',
                          borderRadius: '50%',
                          p: 1.25,
                          boxShadow: theme => `0 0 20px ${theme.palette.primary.dark}99`
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: '0.6rem !important',
                            color: "primary.dark"
                          }}
                        >
                          {t(`qrTemplate.${customData?.subtitle}`)}
                        </Typography>
                      </Box>
                    </Grid>
                  }
                </Grid>

                {editMode && renderDescriptionEdit(attributes.find(att => att.name === 'description'))}

                {attributes.some(att => att.name === 'description') && 
                  <Typography color='text.primary' variant='h2' style={{ paddingTop: '3rem' }} >
                    {t('qrTemplate.traceabilityInformation')}
                  </Typography>
                }

                {orderAttributesWithSections(enhancedAttributes, sections).map((section, sectionIndex) => (
                  section.attributes.length > 0 && (<>
                    {section.title ? (
                      <Accordion 
                        key={sectionIndex} 
                        sx={!editMode && {
                          borderRadius: 5, 
                          marginTop: 2,
                          '&::before': {
                            display: 'none'
                          },
                        }}
                      >
                        <AccordionSummary 
                          expandIcon={<ExpandMoreIcon/>}
                        >
                          <Typography color='primary.main' variant='h3' className='p-2'>
                            {`${translateFunc(
                              t,
                              `basicFormStepByStep.stepsTranslate.${section.title}`,
                              section.title
                            )}${(section.boxName) ? ` - ${section.boxName}` : ''}`}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          {section.attributes.map((att, attIndex) => renderAttributeBlock(att, attIndex))}
                        </AccordionDetails>
                      </Accordion>
                    ) : (
                      section.attributes.map((att, attIndex) => renderAttributeBlock(att, attIndex))
                    )}
                  </>)
                ))}

                {editMode &&
                  <div style={{ paddingTop: '1rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }} >
                    <Button variant='outlined' onClick={() => history.goBack()} disabled={isLoading}>{t('qrTemplate.buttons.cancel')}</Button>
                    <Button variant='outlined' sx={{display: 'inline-flex', justifyContent: 'center', alignItems: 'center', gap: 1 }} type='submit' disabled={isLoading}>
                      {isLoading && <CircularProgress size={14} style={{color: 'inherit'}}/>}
                      {t('qrTemplate.buttons.saveTemplate')}
                    </Button>
                  </div>
                }
              </Container>
              <Footer tt={t} qrModelLogo={qrModelLogo} />
            </>
          }
        </CustomThemeProvider>
      </StylesProvider>
    </StyledEngineProvider>
  );
};
